/* eslint-disable */
import cookiePolicyGetAccepted from './getCookiePolicyAccepted';

export const getCookiePolicyAccepted = cookiePolicyGetAccepted;
